const LEGACY_ID_PREFIX = 'legacy.';

export const mapAcFeatures = (acFeatures) => acFeatures
  .filter((f) => f.compoundFeatureID !== undefined && f.value !== undefined && f.value.value !== undefined)
  .filter((f) => !f.compoundFeatureID.startsWith(LEGACY_ID_PREFIX))
  .reduce((map, f) => {
    // eslint-disable-next-line no-param-reassign
    map[f.compoundFeatureID] = f.value.value;
    return map;
  }, {});

export const resolveLDClientId = (zone) => {
  const clientIdMap = new Map([
    ['z0', '6127bd647ee31e2579176f0d'], // qa
    ['z1-a', '6127bd647ee31e2579176f05'],
    ['z1', '6127bd647ee31e2579176f0f'],
    ['z2', '6127bd647ee31e2579176f0b'],
    ['z3', '6127bd647ee31e2579176f09'],
  ]);
  return clientIdMap.get(zone);
};

export function isDevEnv() {
  return process.env.NODE_ENV === 'development';
}

export const isEmptyObject = (obj) => isObject(obj) && (obj && Object.keys(obj).length === 0 && obj.constructor === Object);

export const isObject = (value) => {
  const type = typeof value;
  return value != null && (type === 'object' || type === 'function');
};

export const encodeData = (data) => window.btoa(encodeURIComponent(JSON.stringify(data)));

export const decodeData = (data) => {
  if (data) {
    try {
      const decodedData = window.atob(data);
      return JSON.parse(decodeURIComponent(decodedData));
    } catch (err) {
      return data;
    }
  }
  return undefined;
};

export const getHttpsURL = (domain) => `https://${domain}`;

export const encodeUnicodeObject = (obj) => encodeURIComponent(JSON.stringify(obj));
